export default "__VITE_ASSET__CEsRQKcF__"